import React from "react";
import { IconDoorBack, LogoCurrent } from "assets/svg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cleanData } from "reducers/authSlice";
import { AppDispatch } from "store/store";
import { menuSeller } from "./MenuSeller";

const SidebarSeller = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const logout = () => {
    dispatch(cleanData());
    navigate("/");
  };

  return (
    <div className="hidden md:flex md:w-[240px] md:h-full md:fixed px-[20px] pt-[40px] pb-[30px] flex-col justify-between items-center gap-[40px] shrink-0 self-stretch bg-primary">
      <div className="md:flex flex-col gap-[40px]">
        {/*Logo*/}
        <Link
          to="/seller/dashboard"
          className="flex h-[55px] justify-center items-center aspect-[30/11]"
        >
          <LogoCurrent className="w-[150px] h-[60px] shrink-0" />
        </Link>
        {/*Nav*/}
        <div className="max-h-[868px] flex w-[200px] flex-col items-start gap-[10px] flex-[1_0_0]">
          {menuSeller.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex w-[200px] px-[30px] py-[10px] pl-[10px] items-center gap-[10px] rounded-[6px] ${
                  isActive ? "bg-white text-primary" : "bg-primary text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className="w-[20px] h-[20px] shrink-0 aspect-[1/1]">
                    {isActive ? item.iconActive : item.icon}
                  </div>
                  <div className="h-[22px] font-['Noto Sans JP'] text-[14px] not-italic font-bold leading-[160%] whitespace-nowrap">
                    {item.label}
                  </div>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
      {/*Foot*/}
      <div className="flex flex-col items-start gap-[10px] self-stretch">
        <div
          className="flex w-[200px] px-[30px] py-[10px] pl-[10px] items-center gap-[10px] rounded-[6px] bg-primary"
          onClick={logout}
        >
          <IconDoorBack className="w-[20px] h-[20px] shrink-0 aspect-[1/1]" />
          <div
            onClick={logout}
            className="h-[22px] text-white font-['Noto Sans JP'] text-[14px] not-italic font-bold leading-[160%] whitespace-nowrap cursor-pointer"
          >
            ログアウト
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarSeller;
